export default __webpack_public_path__ + "static/media/adejoke.83f15370.png";